export default '/src/assets/webgl/pedro/audios/global_outro.mp3'